module.exports = __webpack_public_path__ + "img/danone-carousel.3fa5f789.png";